
/** Returns true if the specified Australian state (by code) is serviced by 13CABS. */
export function IsSupportedStateCode(stateCode: string) {

    // placeholder implementation
    // TODO: once we have a proper copy of the metadata, do a lookup vs the state code.
    // As of April-2020, we service in all the states in Australia. Hence this always returns true.
    return true;
}
